import React, { Fragment } from 'react'
import Link from 'next/link'

import getLinkHref from 'lib/url'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Image from 'Components/image'

import { ICarList } from '../interface'

interface IProps {
  /* 汽车详细数据 */
  list: ICarList
  /* 显示的月份还是第几的icon */
  hasIcon?: boolean
  /* 显示的是价格还是销量 */
  isOrigin?: boolean
  /* 显示第几的icon */
  index?: number
  // 用于统计，表明来自哪个组件
  from?: string
}

export default function CarList({
  list,
  from = '',
  index = 1,
  hasIcon = true,
  isOrigin = true,
}: IProps) {
  // background: url(${require(`static/${index}_img@3x.png`)}) no-repeat
  //             center / 36px 36px;
  return (
    <div className="series clearfix">
      {hasIcon ? (
        <span className="icon" />
      ) : (
        <span className="month">{list.online_date.slice(0, 2)}</span>
      )}
      <Link
        href={`/auto/series?seriesId=${list.series_id}`}
        as={`/auto/series/${list.series_id}`}
      >
        <a
          target="_blank"
          title={list.series_name}
          onClick={() => {
            sendTeaCommEvent(from, {
              car_series_name: list.series_name,
              car_series_id: list.series_id,
              rank: index,
            })
          }}
        >
          <Image className="photo" src={list.image || list.cover_url || ''} />
          <span className="name line-1">{list.series_name}</span>
          {isOrigin ? (
            <span className="active price">
              {`${
                list.price
                  ? list.price
                  : `${list.min_price}-${list.max_price}万`
              } `}
            </span>
          ) : (
            <span className="price">总销量 {list.count}</span>
          )}
        </a>
      </Link>
      <style jsx>
        {`
          .series {
            height: 60px;
            margin: 16px 14px 0 12px;
          }
          .icon {
            display: inline-block;
            width: 36px;
            height: 36px;
            margin-right: 4px;
            vertical-align: middle;
            background: url(${require(`static/${index}_img@3x.png`)}) no-repeat
              center / 36px 36px;
          }
          .month {
            margin-right: 7px;
            font-size: 18px;
            font-weight: 500;
            vertical-align: text-top;
          }
          .series :global(.photo) {
            display: inline-block;
            width: 90px;
            height: 60px;
            margin-right: 12px;
            vertical-align: middle;
          }
          .name {
            display: inline-block;
            width: 100px;
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            vertical-align: text-top;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            transition: color 0.3s ease-in-out;
          }
          .name:hover {
            color: #406599;
          }
          .active {
            color: #ff9100;
            font-weight: 500;
          }
          .active:hover {
            text-decoration: underline;
            cursor: pointer;
          }
          .price {
            float: right;
            margin-top: 20px;
            margin-right: 12px;
          }
        `}
      </style>
    </div>
  )
}
